import {
  createActions
} from 'redux-actions';
import * as Types from './constants';

export default createActions({
  [Types.AUTHENTICATION_ATTEMPT]: (strategy, email, password) => ({ strategy, email, password }),
  [Types.AUTHENTICATION_SUCCESS]: (token, user) => ({ token, user }),
  [Types.AUTHENTICATION_FAILURE]: (error) => ({ error }),
  [Types.LOG_OUT]: () => ({})
});


// WEBPACK FOOTER //
// ./client/store/actions/authenticationActions.js